module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp23_8023.7fd2e1a8.png";